export class LanguageList {
  id: string;
  title: string;
}

export class LocalizationHelper {
  public static get getLanguageList(): LanguageList[] {
    const listLanguage: LanguageList[] = [
      {
        id: 'ru',
        title: 'Русский',
      },
      {
        id: 'en',
        title: 'English',
      },
      {
        id: 'hy',
        title: 'Հայերեն',
      },
      {
        id: 'vi',
        title: 'Tiếng Việt',
      },
      {
        id: 'lv',
        title: 'Latvietis',
      },
      {
        id: 'lt',
        title: 'Lietuviešu',
      },
      {
        id: 'uk',
        title: 'Українська',
      },
      {
        id: 'pl',
        title: 'Polski',
      },
      {
        id: 'de',
        title: 'Deutsch',
      },
      {
        id: 'id',
        title: 'Indonesia',
      },
      {
        id: 'ro',
        title: 'Română',
      },
    ];
    return listLanguage;
  }

  public static getLocalizedNumberCodeByISOCode(isoCode: string): string {
    switch (isoCode) {
      case 'RUB':
        return 'ru_NRU';

      case 'BYR':
      case 'BYN':
        return 'by_BYN';

      case 'UAH':
        return 'ua_UAH';

      case 'KZT':
        return 'kz_KZT';

      case 'USD':
        return 'en_US';

      case 'GBP':
        return 'en_GB';

      case 'CAD':
        return 'en_CA';

      case 'EUR':
        return 'de_DE';

      case 'CNY':
        return 'zh_CN';

      case 'PLN':
        return 'pl_PL';

      case 'IDR':
        return 'id_IDR';

      default:
        return 'COMMON';
    }
  }
}
